import type { RootState } from 'app/store/reducer';

export const activeElementLinkIdSelector = (state: RootState) => state.activeElement.linkId;
